export const MEDICAL_QUESTIONS = {
  'health-fg': {
    questions: [
      {
        key: 'Q1',
        text: 'Is the person already have Health Total policy of Future Generali?',
      },
      {
        key: 'Q2',
        text: 'Is the person in good health and free from physical and mental disease or infirmity or medical complaints or deformity?',
      },
      {
        key: 'Q3',
        text: 'Is the person have at present or in the past had any health complaints, signs or symptoms, or were taking treatment or were hospitalized for any illness?',
      },
      {
        key: 'Q4',
        text: 'Is the person at present or in the past met with any accident / injury or were hospitalized or taking treatment for any accident injury?',
      },
      {
        key: 'Q5',
        text: 'Is the person undergone any surgery in the past or going for any planned surgery at present / recent future?',
      },
      { key: 'Q6', text: 'Is the person Indian resident?' },
      {
        key: 'Q7',
        text: 'Whether any Health Insurance Policy has been declined?',
      },
      { key: 'Q8', text: 'Do you smoke?' },
    ],
    validationRules: {
      regretIfYes: ['Q1', 'Q3', 'Q4', 'Q5', 'Q7'],
      regretIfNo: ['Q2', 'Q6'],
      smokingKey: 'Q8',
    },
  },
};
